<template>
  <v-container class="ml-0">
    <v-navigation-drawer
      v-model="show"
      fixed
      temporary
      right
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title dark ">
              Settings</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
                                                    <!--
                                                          <v-divider></v-divider>
                                                                <v-row justify="space-around">
                                                    -->
        <div class="settingsCheckboxDiv">

            <h4>DAY PREFERENCES</h4>
          <v-row>
            <v-checkbox
                dense
                class="ml-3 settingsCheckbox font-italic"
                label="Sat"
                v-model="preferredDayOfWeekSat"
            ></v-checkbox>
            <v-checkbox
                dense
                class="ml-3 settingsCheckbox font-italic"
                label="Sun"
                v-model="preferredDayOfWeekSun"
            ></v-checkbox>
          </v-row>
          <v-row>
            <v-checkbox
                dense
                class="ml-3 settingsCheckbox font-italic"
                label="Mon"
                v-model="preferredDayOfWeekMon"
            ></v-checkbox>
            <v-checkbox
                dense
                class="ml-3 settingsCheckbox font-italic"
                label="Tue"
                v-model="preferredDayOfWeekTue"
            ></v-checkbox>
            <v-checkbox
                dense
                class="ml-3 settingsCheckbox font-italic"
                label="Wed"
                v-model="preferredDayOfWeekWed"
            ></v-checkbox>
          </v-row>
          <v-row>
            <v-checkbox
                dense
                class="ml-3 settingsCheckbox font-italic"
                label="Thu"
                v-model="preferredDayOfWeekThu"
            ></v-checkbox>
            <v-checkbox
                dense
                class="ml-3 settingsCheckbox font-italic"
                label="Fri"
                v-model="preferredDayOfWeekFri"
            ></v-checkbox>
          </v-row>

            <!-- class="ml-3 mr-3" 
            
                        v-model="timePreferenceEarliest"
            @change="uppercaseE" 
            @keyup="uppercaseE" 

            -->

            <h4>TIME PREFERENCES</h4>

              <v-layout row>
              <v-flex xs4 offset-xs1>
                  <v-text-field 
                    v-model="timePreferenceEarliest"
                    label="Earliest Time"
                    placeholder="08:00 AM"
                    style="width: 70px"
                  ></v-text-field>
              </v-flex>

              <v-flex xs5>
                  <v-text-field 
                    v-model="timePreferenceLatest"
                    label="Latest Time"
                    placeholder="05:00 PM"
                    style="width: 70px"
                  ></v-text-field>
              </v-flex>
              <!-- Error line for Chelsea time format and outside the 8-5 time window -->
              <v-flex xs10 offset-xs1 v-if='timeErrorE!="" || timeErrorL!=""'>
                <span class="tRed tSmall mr-2">
                  {{ timeErrorE }} 
                  {{ timeErrorL }}
                </span>
              </v-flex>

            </v-layout>

            <h4>OTHER PLAYERS</h4>

              <v-switch
                dense
                class="settingsCheckbox font-italic"
                label="Show 1, 2, 3 openings"
                v-model="show123Players"
                v-bind:false-value=false
                v-bind:true-value=true
                />


            <h4>ALERTS</h4>

              <v-switch
                dense
                class="settingsCheckbox font-italic"
                label="Show Tee Sheet Changes"
                v-model="showDiffs"
                v-bind:false-value=false
                v-bind:true-value=true
                />
                              <!--   showDiffs={{showDiffs}} -->
                                
                <div v-if="showDiffs">
                  <p class='tSmall'>You can be Alerted to Changes:</p>

                  <v-switch
                      dense
                      class="settingsCheckbox font-italic"
                      label="via Audio"
                      v-model="showDiffsViaAudio"
                      v-bind:false-value=false
                      v-bind:true-value=true
                      />
                                                  <!--    showDiffsViaAudio={{showDiffsViaAudio}} -->

                      <v-container v-if="this.showDiffsViaAudio">
                        <v-select
                          class="ml-3 pt-0 mt-0"
                          v-model="audioClipSelected"
                          :items="audioClips"
                          label="Alert Sound"
                          dense
                          style="width: 110px"
                        ></v-select>
                      </v-container>
                                                  <!--    audioClipSelected={{audioClipSelected}} -->

                  <v-switch
                      dense
                      class="settingsCheckbox font-italic"
                      label="via TextMessage"
                      v-model="showTextMessages"
                      v-bind:false-value=false
                      v-bind:true-value=true
                      />

                      <v-text-field v-if="showTextMessages"
                        class="ml-3 pt-0 mt-0"
                        v-model="textMessagePhone"
                        label="10 digit Phone #"
                        counter
                        style="width: 129px"
                      ></v-text-field>
                </div>

<v-divider></v-divider>

            <h4>ADVANCED</h4>

              <v-switch
                dense
                class="settingsCheckbox font-italic"
                label="Show Technical Info"
                v-model="showTechnical"
                v-bind:false-value=false
                v-bind:true-value=true
                />


              <span class="tSmallest">state.settings={{$store.state.settings}}</span>


                          <!--
                            <v-list-item>
                              <v-select
                              v-model="filterBy"
                              :items="tags"
                              attach
                              chips
                              label="Filter by..."
                              multiple
                              clearable
                              menu-props="closeOnClick"
                              aria-label="Filter Metrics"
                              ></v-select>
                            </v-list-item>

                            <v-list dense>

                              <v-list-item
                                v-for="item in dataConfig"
                                :key="item.metric"
                              >

                                <v-list-item-content>
                                  <v-checkbox
                                    :label="item.title"
                                    v-model="metric"

                                    :value="item.metric"
                                    height=0
                                  ></v-checkbox>
                                  <v-icon v-if="site.whatsnew.indexOf(item.metric) !== -1" class="new" color="pink">{{ mdiNewBox }}</v-icon>
                                </v-list-item-content>
                              </v-list-item>

                            </v-list>
                          -->

                          <!--
                                      <v-switch
                                          dense
                                          class="settingsCheckbox font-italic"
                                          label="Show Graphs"
                                          v-model="showGraphs2"
                                          v-bind:false-value=false
                                          v-bind:true-value=true
                                          />

                                      <p>SHOW FEATURES</p>

                                      -->
                                      <!--

                                    this.$store.state.settings.showChoropleth =  {{this.$store.state.settings.showChoropleth}}
                          [ {{showChoropleth2}} ]
                          -->
                                      <!--
                                          value=true

                                      this.$store.state.settings.showMapVars =  {{this.$store.state.settings.showMapVars}}
                                      [ {{showMapVars2}} ]

                                      <v-switch
                                          dense
                                          class="settingsCheckbox font-italic"
                                          label="Map Coordinates"
                                          v-model="showMapVars2"
                                          v-bind:false-value=false
                                          v-bind:true-value=true
                                          />

                                      <v-switch
                                          dense
                                          class="settingsCheckbox font-italic"
                                          label="Export Option"
                                          v-model="showExport"
                                          v-bind:false-value=false
                                          v-bind:true-value=true
                                          />

                                      <p>SHOW TECHNICAL</p>

                                      <v-switch
                                          dense
                                          class="settingsCheckbox font-italic"
                                          label="Card Index"
                                          v-model="showCardIndex2"
                                          v-bind:false-value=false
                                          v-bind:true-value=true
                                          />
                                      <v-switch
                                          dense
                                          class="settingsCheckbox font-italic"
                                          label="Card Metric#"
                                          v-model="showCardMetricId2"
                                          v-bind:false-value=false
                                          v-bind:true-value=true
                                          />

                                      <v-divider class="mb-3"/>

                                      <p>IN DEVELOPMENT</p>

                                      <v-switch
                                          dense
                                          class="settingsCheckbox font-italic"
                                          label="Geocoder"
                                          v-model="showGeocoder2"
                                          v-bind:false-value=false
                                          v-bind:true-value=true
                                          />

                                      <v-checkbox
                                          dense
                                          class="settingsCheckbox font-italic"
                                          label="Years"
                                          v-model="showYears"
                                      ></v-checkbox>

                          -->

                                      <!--

                                    this.$store.state.settings.showMarkers =  {{this.$store.state.settings.showMarkers}}
                          [ {{showMarkers2}} ]
                                      <v-checkbox
                                          dense
                                          class="settingsCheckbox font-italic"
                                          label="Markers"
                                          v-model="showMarkers2"
                                          v-bind:false-value=false
                                          v-bind:true-value=true
                                      ></v-checkbox>

                                      <v-switch
                                          dense
                                          class="settingsCheckbox font-italic"
                                          label="Scale"
                                          v-model="showScale2"
                                          v-bind:false-value=false
                                          v-bind:true-value=true
                                          />
                          -->


        </div>

    </v-navigation-drawer>
  </v-container>
</template>

<script>
  //import { mdiNewBox } from '@mdi/js'

  export default {
    name: 'dataselector',
    props: {
      value: Boolean
    },

    data: () => ({

      filterBy: [],

      timePreferenceEarliest: "08:00 AM",
      timePreferenceLatest: "05:00 PM",
      timeErrorE: "",
      timeErrorL: "",

      show123Players: false,

      showDiffs: true,

      showDiffsViaAudio: false,
      audioClips: ['desk bell', 'tolling bell', 'trumpet', 'rooster'],
      audioClipSelected: "",

      showTextMessages: false,
      textMessagePhone: "",

      preferredDayOfWeekSun: false,
      preferredDayOfWeekMon: false,
      preferredDayOfWeekTue: false,
      preferredDayOfWeekWed: false,
      preferredDayOfWeekThu: false,
      preferredDayOfWeekFri: false,
      preferredDayOfWeekSat: false,

      //mask: '###-###-####',
      showTechnical: false,



    }),

                                                /*
                                                    directives: {
                                                      mask,
                                                    },
                                                */
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      },
      metric: {
        get() {
          return this.$store.state.metric
        },
        set(value) {
          this.$store.commit("setMetric", value)
        }
      },
      dataConfig() {
        if (this.filterBy.length > 0) {
          return this.$store.state.dataConfig.filter(el => {
            const uniques = [...new Set([...el.tags, ...this.filterBy])]
            return uniques.length !== this.filterBy.length + el.tags.length
          })
        }
        return this.$store.state.dataConfig
      },
      tags() {
        let tags = []
        this.$store.state.dataConfig.forEach(el => {
          tags = [...new Set([...tags, ...el.tags])]
        })

        return tags.sort()
      },
      site() {
        return this.$store.state.dataOptions
      },
      ssss() {
        return this.$store.state.settings.showMapVars
      }





    },

    watch: {

        showDiffs: function (newVal, oldVal) {
            console.log("showDiffs",newVal, "was",oldVal)
            // update state
            //this.$store.dispatch( 'setShowDiffs', newVal )
            //this.$store.dispatch( 'setSettings', {"settingName":"showDiffs","value":newVal} )
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"showDiffs","value":newVal,"oldValue":oldVal} )
        },
        showDiffsViaAudio: function (newVal, oldVal) {
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"showDiffsViaAudio","value":newVal,"oldValue":oldVal} )
        },
        audioClipSelected: function (newVal, oldVal) {
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"audioClipSelected","value":newVal,"oldValue":oldVal} )
        },
        showTextMessages: function (newVal, oldVal) {
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"showTextMessages","value":newVal,"oldValue":oldVal} )
        },
        textMessagePhone: function (newVal, oldVal) {
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"textMessagePhone","value":newVal,"oldValue":oldVal} )
        },

        preferredDayOfWeekSat: function (newVal, oldVal) {
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"preferredDayOfWeekSat","value":newVal,"oldValue":oldVal} )
        },
        preferredDayOfWeekSun: function (newVal, oldVal) {
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"preferredDayOfWeekSun","value":newVal,"oldValue":oldVal} )
        },
        preferredDayOfWeekMon: function (newVal, oldVal) {
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"preferredDayOfWeekMon","value":newVal,"oldValue":oldVal} )
        },
        preferredDayOfWeekTue: function (newVal, oldVal) {
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"preferredDayOfWeekTue","value":newVal,"oldValue":oldVal} )
        },
        preferredDayOfWeekWed: function (newVal, oldVal) {
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"preferredDayOfWeekWed","value":newVal,"oldValue":oldVal} )
        },
        preferredDayOfWeekThu: function (newVal, oldVal) {
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"preferredDayOfWeekThu","value":newVal,"oldValue":oldVal} )
        },
        preferredDayOfWeekFri: function (newVal, oldVal) {
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"preferredDayOfWeekFri","value":newVal,"oldValue":oldVal} )
        },
 
        timePreferenceEarliest: function (newVal, oldVal) {
            let newEarlyTime = numericTime(newVal)
            if (newVal===undefined) return
            if (newEarlyTime<800 || newEarlyTime>1700) {
              this.timeErrorE = " Invalid Earliest Time - must be 08:00 AM to 05:00 PM. "
              return
            }
            else {
              this.timeErrorE = ""
              //this.timeErrorE = newEarlyTime+" eOK"
            }
            newVal = newVal.toUpperCase();
            this.timePreferenceEarliest = newVal
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"newEarlyTime","value":newEarlyTime,"oldValue":oldVal} )
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"timePreferenceEarliest","value":newVal,"oldValue":oldVal} )
        },
        timePreferenceLatest:function (newVal, oldVal) {
            let newLateTime = numericTime(newVal)
            if (newLateTime<800 || newLateTime>1700) {
              this.timeErrorL = " Invalid Latest Time - must be 08:00 AM to 05:00 PM."
              return
            }
            else {
              this.timeErrorL = ""
              //this.timeErrorL = newLateTime+" lOK"
            }
            newVal = newVal.toUpperCase();
            this.timePreferenceLatest = newVal
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"newLateTime","value":newLateTime,"oldValue":oldVal} )
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"timePreferenceLatest","value":newVal,"oldValue":oldVal} )
        },

        show123Players: function (newVal, oldVal) {
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"show123Players","value":newVal,"oldValue":oldVal} )
        },

        showTechnical: function (newVal, oldVal) {
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"showTechnical","value":newVal,"oldValue":oldVal} )
        },

        showGraphs2: function (newVal, oldVal) {
            console.log("showGraphs2",newVal, "was",oldVal)
            // direct call to mutation
            this.$store.dispatch( 'setShowGraphs', newVal )
        },


        showChoropleth: function (newVal, oldVal) {
            console.log("showChoropleth",newVal, "was",oldVal)
            // direct call to mutation
            this.$store.dispatch( 'setShowChoropleth', newVal )
        },
        showChoropleth2: function (newVal, oldVal) {
            console.log("showChoropleth2",newVal, "was",oldVal)
            // direct call to mutation
            this.$store.dispatch( 'setShowChoropleth', newVal )
        },
        showMarkers2: function (newVal, oldVal) {
            console.log("showMarkers2",newVal, "was",oldVal)
            // direct call to mutation
            this.$store.dispatch( 'setShowMarkers', newVal )
        },
        showMapVars2: function (newVal, oldVal) {
            console.log("showMapVars2",newVal, "was",oldVal)
            // direct call to mutation
            this.$store.dispatch( 'setShowMapVars', newVal )
        },
        showExport: function (newVal, oldVal) {
            console.log("showExport",newVal, "was",oldVal)
            // direct call to mutation
            this.$store.dispatch( 'setShowExport', newVal )
        },        
        showGeocoder2: function (newVal, oldVal) {
            console.log("showGeocoder2",newVal, "was",oldVal)
            // direct call to mutation
            this.$store.dispatch( 'setShowGeocoder', newVal )
        },
        showCardIndex2: function (newVal, oldVal) {
            console.log("showCardIndex2",newVal, "was",oldVal)
            // direct call to mutation
            this.$store.dispatch( 'setShowCardIndex', newVal )
        },
        showCardMetricId2: function (newVal, oldVal) {
            console.log("showCardMetricId2",newVal, "was",oldVal)
            // direct call to mutation
            this.$store.dispatch( 'setShowCardMetricId', newVal )
        },
        showScale2: function (newVal, oldVal) {
            console.log("showScale2",newVal, "was",oldVal)
            // direct call to mutation
            this.$store.dispatch( 'setShowScale', newVal )
        },





    },

  methods: {

         uppercaseE() {
            this.timePreferenceEarliest = this.timePreferenceEarliest.toUpperCase();
         },




        X_timePreferenceEarliest() {
            this.timePreferenceEarliest = this.timePreferenceEarliest.toUpperCase();
        },
        X_timePreferenceLatest() {
            this.timePreferenceLatest = this.timePreferenceLatest.toUpperCase();
        },
  },




    mounted () {


            console.log("~STORE.STATE mounted",this.$store.state.settings)

    },


  }


// chelsea time has format 02:15 PM
// convert to 1415
function numericTime(chelseaTime) {
    if (chelseaTime===undefined || chelseaTime=="" || chelseaTime==null ) return 0;
    const h = chelseaTime.substring(0,2);
    const m = chelseaTime.substring(3,5);
    let ap = chelseaTime.substring(6,8);
    ap = ap.toUpperCase();
    // must end in AM or PM
    if (ap!="AM" && ap!="PM") return 0;
    let t = Number(h*100) + Number(m);
    if (ap.toUpperCase()=="PM" && h!="12") t+=1200;
    return t;
}





</script>

<style lang="scss" scoped>
.title {
    background-color: #9E9E9E;
    padding: 5px;
    color: white;
}

.new {
  position: absolute;
  top: 0px;
  left: 0;
}
.settingsCheckboxDiv {
    margin-left: 16px;
    margin-top: 16px;
    margin-bottom: 16px;
}
.settingsCheckbox {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
}
.v-label {
    font-size: 10px;
}
</style>
